import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ShieldAlert, Home, Phone } from 'lucide-react';
import { COMPANY_INFO } from '../data';

export default function Forbidden() {
  return (
    <>
      <Helmet>
        <title>403: Adgang nægtet | VHMU</title>
        <meta name="description" content="Du har ikke adgang til denne side. Kontakt Vesthimmerlands Materieludlejning på 70 60 55 66 hvis du mener der er tale om en fejl." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16 text-center md:px-6 bg-brand-light">
        <div className="rounded-full bg-red-500/10 p-6 text-red-500 mb-6">
          <ShieldAlert className="h-16 w-16" />
        </div>
        <h1 className="text-5xl font-extrabold uppercase tracking-tight text-white sm:text-6xl">
          403 - Adgang <span className="text-red-500">nægtet</span>
        </h1>
        <p className="mt-4 max-w-md text-lg text-gray-400">
          Du har desværre ikke de nødvendige tilladelser til at se denne side.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link
            to="/"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-brand-yellow px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-brand-yellow-hover transition-all duration-200 sm:w-auto"
          >
            <Home className="h-4 w-4" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="flex w-full items-center justify-center gap-2 rounded-md border border-brand-grey bg-brand-dark px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white hover:bg-brand-light hover:border-brand-yellow transition-all duration-200 sm:w-auto"
          >
            <Phone className="h-4 w-4 text-brand-yellow" />
            <span>Kontakt os</span>
          </Link>
        </div>
      </section>
    </>
  );
}
